import { IMetricModelOutput } from "@edgetier/watchtower-types";
import { isBefore } from "date-fns";

/**
 * Group a model's output by metric.
 * @param metricModelOutputs Outputs of a metric model which could contain more than one metric.
 * @returns                  Data grouped by metric.
 */
export const groupMetrics = (metricModelOutputs: IMetricModelOutput[]) => {
    const groups: { [index: string]: IMetricModelOutput[] } = {};
    metricModelOutputs.forEach((metricModelOutput) => {
        // Create a new group if it doesn't exist.
        if (!(metricModelOutput.metric in groups)) {
            groups[metricModelOutput.metric] = [];
        }

        // Append the output of the metric.
        groups[metricModelOutput.metric].push(metricModelOutput);
    });

    // Sort metrics so that the top is hopefully the most relevant to the anomaly.
    return Object.entries(groups).sort(([_metricOne, outputsOne], [_metricTwo, outputsTwo]) => {
        return outputsTwo[0].metricSquaredError - outputsOne[0].metricSquaredError;
    });
};

/**
 * Given two dates, figure out which one comes first and return an array with the earlier date being first.
 * @param firstDate
 * @param secondDate
 * @returns An array with the earlier date first and the later date second.
 */
export const orderDates = (firstDate: Date, secondDate: Date) => {
    return isBefore(firstDate, secondDate) ? [firstDate, secondDate] : [secondDate, firstDate];
};
